import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { VFButton, VFText, Icon } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, Types } from '@vfgroup-oneplatform/foundation/Components/Themes';

import styles from './AddOnsInlineContent.styles';

const AddOnsInlineContent = ({
  leftIcon,
  title,
  subtitle,
  rightIcon,
  description,
  buttonTitle,
  onButtonPress,
  containerStyle,
  mainContentStyle,
  iconStyle,
  titleAndSubtitleContainerStyle,
  titleStyle,
  subtitleStyle,
  imageStyle,
  separatorStyle,
  descriptionAndButtonContainerStyle,
  descriptionStyle,
  buttonStyle,
  buttonTextStyle,
  theme,
  ...extraData
}) => {
  const addOnData = {
    ...extraData,
    title,
    description,
  };

  return (
    <View style={[styles.container(theme), containerStyle]}>
      <View style={[styles.mainContent, mainContentStyle]}>
        <Icon name={leftIcon} style={[styles.icon, iconStyle]} type="image" />
        <View style={[styles.titleAndSubtitleContainer, titleAndSubtitleContainerStyle]}>
          <VFText i18nKey={title} style={[styles.title(theme), titleStyle]} />
          <VFText i18nKey={subtitle} style={[styles.subtitle(theme), subtitleStyle]} />
        </View>
        <View style={styles.rightIconContainer(theme)}>
          <Icon name={rightIcon} style={[styles.image, imageStyle]} type="image" />
        </View>
      </View>
      <View style={[styles.separator(theme), separatorStyle]} />
      <View style={[styles.descriptionAndButtonContainer, descriptionAndButtonContainerStyle]}>
        <VFText i18nKey={description} style={[styles.description(theme), descriptionStyle]} />
        <VFButton
          title={buttonTitle}
          onPress={() => onButtonPress(addOnData)}
          style={[styles.button, buttonStyle]}
          textStyle={[styles.buttonText, buttonTextStyle]}
          type={Types.PRIMARY}
        />
      </View>
    </View>
  );
};

AddOnsInlineContent.propTypes = {
  leftIcon: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  title: PropTypes.string,
  subtitle: PropTypes.string,
  rightIcon: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  description: PropTypes.string,
  buttonTitle: PropTypes.string,
  onButtonPress: PropTypes.func,
  containerStyle: ViewPropTypes.style,
  mainContentStyle: ViewPropTypes.style,
  iconStyle: ViewPropTypes.style,
  titleAndSubtitleContainerStyle: ViewPropTypes.style,
  titleStyle: ViewPropTypes.style,
  subtitleStyle: ViewPropTypes.style,
  imageStyle: ViewPropTypes.style,
  separatorStyle: ViewPropTypes.style,
  descriptionAndButtonContainerStyle: ViewPropTypes.style,
  descriptionStyle: ViewPropTypes.style,
  buttonStyle: ViewPropTypes.style,
  buttonTextStyle: ViewPropTypes.style,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};

export default withTheme(AddOnsInlineContent);
